// ============================================================================
// SHARED RCA TYPES (used by both IncidentManagement & FireIncidentInvestigation)
// ============================================================================

/**
 * RCA Team Member interface
 */
export interface RCATeamMember {
  srNo: number;
  name: string;
  department: string;
  isLead: boolean;
}

/**
 * Timeline Event interface
 */
export interface TimelineEvent {
  srNo: number;
  date: string;
  time: string;
  event: string;
}

/**
 * Witness Statement interface
 */
export interface WitnessStatement {
  witnessName: string;
  statement: string;
  contactInfo?: string;
}

/**
 * Consequence interface
 */
export interface Consequence {
  srNo: number;
  type: string;
  isYes: boolean;
  remark: string;
}

/**
 * Fishbone Analysis Categories
 */
export interface FishboneAnalysis {
  man: string[];
  material: string[];
  machine: string[];
  system: string[];
  management: string[];
}

/**
 * Why-Why Analysis Entry
 */
export interface WhyWhyAnalysisEntry {
  question: string;
  answer: string;
  level: number;
}

/**
 * Contributing Factor interface
 */
export interface ContributingFactor {
  srNo: number;
  factor: string;
  observation: string;
  isApplicable: boolean;
}

/**
 * Corrective Action Plan interface
 */
export interface CorrectiveActionPlan {
  srNo: number;
  rootCauseOrContributingFactor: string;
  correctiveAction: string;
  responsiblePersonOrTeam: string;
  deadline: string;
  status: "Pending" | "In Progress" | "Completed";
  completionDate?: string;
  monitoringNotes?: string;
}

/**
 * Preventive Action Plan interface
 */
export interface PreventiveActionPlan {
  srNo: number;
  // rootCauseOrContributingFactor: string;
  preventiveAction: string;
  responsiblePersonOrTeam: string;
  // deadline: string;
  // status: "Pending" | "In Progress" | "Completed";
  // completionDate?: string;
  // monitoringNotes?: string;
}

/**
 * Contributing Factor Template (from Section G)
 */
export const CONTRIBUTING_FACTORS_TEMPLATE: Omit<
  ContributingFactor,
  "srNo" | "observation" | "isApplicable"
>[] = [
    { factor: "Is the component not designed according to the Indian & international standards" },
    { factor: "Was there malfunction or misuse of any equipment or defective equipment?" },
    { factor: "Was there a lack or inadequacy of safety devices/ equipment needed?" },
    { factor: "Was there any environmental factors and poor storage practices, which lead to the spread of fire?" },
    { factor: "Was there a lack of action or inaction from the staffs?" },
    { factor: "Were the staff trained to handle, extinguish and support evacuation during the fire incident?" },
    { factor: "Was there lack of communication and ambiguity in delegation to report the incident?" },
    { factor: "Are the staff levels adequate?" },
    { factor: "Were there inspection & preventive maintenance programme?" },
    { factor: "Were there any other factors that contributed to fire?" },
  ];

